import { clearApiRequestCache } from '../services/apiRequestCache';
import { notifyAuthTokenChanged } from '../constants/authEvents';
import { clearStoredAccountPathway } from '../constants/accountTypes';
import { clearAdminPortalSession } from './adminPortalSession';
import { clearPartnerPortalSession } from './partnerPortalSession';
import { clearCookieAuthPreference } from './sessionAuth';

/**
 * Clears local auth markers for web login workflows (token, cookie preference,
 * portal sessions, MSME registration cache). Does not call the server logout API.
 */
export const clearClientAuthSession = (): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem('token');
    clearCookieAuthPreference();
    notifyAuthTokenChanged();
    clearApiRequestCache();
    localStorage.removeItem('msmeRegistration');
    clearStoredAccountPathway();
    clearAdminPortalSession();
    clearPartnerPortalSession();
  } catch (error) {
    console.warn('Unable to clear client authentication session.', error);
  }
};
